import { render, staticRenderFns } from "./HaikuContest.vue?vue&type=template&id=593f5715&"
import script from "./HaikuContest.vue?vue&type=script&lang=js&"
export * from "./HaikuContest.vue?vue&type=script&lang=js&"
import style0 from "./HaikuContest.vue?vue&type=style&index=0&id=593f5715&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports